import React, { useState } from "react";
import Menubinder from "../menu";
import Facturacion from "../facturacion";

function VerFacturacion() {
  const [menuOpen, setMenuOpen] = useState(true);
  const sidebarWidth = menuOpen ? 220 : 64;

  return (
    <div
      className="facturacion-layout"
      style={{ display: "flex", minHeight: "100vh", background: "#050c13" }}
    >
      <Menubinder
        defaultOpen={menuOpen}
        onToggle={(next) => setMenuOpen(next)}
      />

      <main
        className="contenido-panel"
        style={{
          marginLeft: sidebarWidth,
          width: `calc(100% - ${sidebarWidth}px)`,
          minWidth: 0,
          transition: "margin-left .25s ease, width .25s ease",
          padding: 0,
          background: "transparent",
        }}
      >
        <Facturacion />
      </main>
    </div>
  );
}

export default VerFacturacion;
